import axios from 'axios';
import { getToken } from './auth';

const API_URL = 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getBarcodePricingRule = async () =>
  (await axios.get(`${API_URL}/settings/barcode-pricing-rule`, withAuth())).data;

export const updateBarcodePricingRule = async (rule) =>
  (await axios.put(`${API_URL}/settings/barcode-pricing-rule`, rule || {}, withAuth())).data;

export const getBranchRequestConfig = async () =>
  (await axios.get(`${API_URL}/settings/branch-request-config`, withAuth())).data;

export const updateBranchRequestConfig = async (config) =>
  (await axios.put(`${API_URL}/settings/branch-request-config`, config || {}, withAuth())).data;
